import React from "react";
import { Button } from "react-bulma-components";

function Loading(props) {
  return <Button loading color={props.color || "white"} />;
}

export default Loading;
